import { createApp, defineAsyncComponent } from 'vue';
import store from './store';

import Controller from './controller';
// import './scss/index.scss'

htmlReady(() => {
	createComponent('#knd-header', 'header');
	createComponent('#knd-kaart', `kaart/index.vue`);
})

function createComponent(el, loc) {
	if(!document.querySelector(el)) return;

		const app = createApp(Controller);
		
		const Component = defineAsyncComponent(() => {
			return import((`./components/${loc}`));
		});

		app.component("dynamic-component", Component);
		app.use(store);
		app.mount(el);
}

// wait till everything is rendered 
function htmlReady(cb){
	// in case the document is already rendered
	if (document.readyState!='loading'){
		cb();
	}

	// modern browsers
	else if (document.addEventListener){ 
		document.addEventListener('DOMContentLoaded', cb);
	}
	// IE <= 8
	else document.attachEvent('onreadystatechange',() => {
		if (document.readyState=='complete') cb();
	});
}